import { DateTime } from 'luxon'

import SATUserQ from '@/queries/SATUserQ'
import UserQ from '@/queries/UserQ'
import type { UserContextType } from '@/client/context/user'
import type { RootQuery } from '@/client/query'
import type { SATBootcampLearnerOnboardingState } from '@/client/services/satBootcamp/types'

export default function satBootcampLearnerOnboardingStateFromQuery({
  query,
  user,
}: {
  query: RootQuery
  user: UserContextType
}): SATBootcampLearnerOnboardingState {
  const me = query.one(
    UserQ.where({
      id: user.id,
    })
  )
  const satUser = query.one(SATUserQ.where({ userId: user.id, type: 'learner' }))
  const parentConsentCompletedAt = me(UserQ.parent_consent_completed_at)
  const parentConsentWaivedAt = me(UserQ.parent_consent_waived_at)
  const parentConsentRequestedAt = me(UserQ.parent_consent_requested_at)
  const parentEmail = me(UserQ.parent_email) ?? ''
  const assentCompletedAt = me(UserQ.assent_completed_at)
  const crosswalkId = satUser(SATUserQ.crosswalk_id)

  const registeredForBootcamp = me(UserQ.isRegisteredForSATBootcamp(UserQ.id)) ?? false

  return {
    parentConsentCompletedAt:
      parentConsentCompletedAt == null ? null : DateTime.fromISO(parentConsentCompletedAt),
    parentConsentWaivedAt:
      parentConsentWaivedAt == null ? null : DateTime.fromISO(parentConsentWaivedAt),
    assentCompletedAt: assentCompletedAt == null ? null : DateTime.fromISO(assentCompletedAt),
    parentEmail,
    parentConsentRequestedAt:
      parentConsentRequestedAt == null ? null : DateTime.fromISO(parentConsentRequestedAt),
    crosswalkId,
    registeredForBootcamp,
  }
}
